import React from 'react'
import { Link } from 'react-router-dom'
import { getProperty } from '../../helpers/properties';
import NotificationDropdown from './NotificationDropdown'
import UserDropdown from './UserDropdown'
import { connect } from 'react-redux'
import { toggleSearch } from '../../actions'
import {getConfiguration} from "../../helpers/configuration";

const mapStateToProps = ({ isSearchActive, currentUser }) => {
  return {
    isSearchActive: isSearchActive,
    userRole: currentUser.data['role']
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleSearchActive: (isSearchActive = false) => {
      dispatch(toggleSearch(isSearchActive))
    }
  }
}

class StickyHeaderUserInfo extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.isSearchActive !== this.props.isSearchActive &&
      !this.props.isSearchActive &&
      this.searchIcon &&
      this.searchIcon.focus
    ) {
      this.searchIcon.focus()
    }
  }

  handleSearchIconClick = () => {
    window.dataLayer.push({
      event: 'custom.form.open',
      group: 'MyVU Search',
      labelContext: undefined,
      taxonomy: {
        category: 'Search'
      },
      info: undefined,
      data: {
        value: undefined
      }
    })

    this.props.toggleSearchActive(true)
  }

  render() {
    if (this.props.userRole != 'STUDENT') {
      return null
    }

    return (
      <div className="user-info">
        <button
          className="header-button header-icon header-search"
          ref={ref => (this.searchIcon = ref)}
          onClick={this.handleSearchIconClick}
        >
          <span className="sr-only">Open Search form</span>
        </button>
        <Link
          className="header-button header-icon header-favourite"
          to={getConfiguration('baseUrl') + '/favourites'}
        >
          <span className="sr-only">Go to Favourites page</span>
        </Link>
        <NotificationDropdown />
        <UserDropdown preferredName={this.props.preferredName} />
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StickyHeaderUserInfo)
